"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");

var UploadNotificationSeverityEnum_1 = require("../model/UploadNotificationSeverityEnum");
/**
 *
 * @author Jaroslav Sevcik
 */


var DataUploadConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(DataUploadConverter, _DataObjectConverter_);

  function DataUploadConverter() {
    _classCallCheck(this, DataUploadConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(DataUploadConverter).apply(this, arguments));
  }

  _createClass(DataUploadConverter, null, [{
    key: "deserializeNotification",
    value: function deserializeNotification(conversions) {
      return function (document) {
        return Object.assign(Object.assign({}, document), {
          severity: conversions.asEnum(document.severity, UploadNotificationSeverityEnum_1.UploadNotificationSeverityEnum)
        });
      };
    }
  }, {
    key: "serializeNotification",
    value: function serializeNotification(conversions) {
      return function (object) {
        return Object.assign({}, object);
      };
    }
  }]);

  return DataUploadConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.DataUploadConverter = DataUploadConverter;